var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { cn } from '../../lib/utils';
var FloatingButton = React.forwardRef(function (_a, ref) {
    var className = _a.className, icon = _a.icon, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, _c = _a.position, position = _c === void 0 ? 'bottom' : _c, _d = _a.isInputExpanded, isInputExpanded = _d === void 0 ? false : _d, _e = _a.inline, inline = _e === void 0 ? false : _e, props = __rest(_a, ["className", "icon", "variant", "position", "isInputExpanded", "inline"]);
    return (React.createElement("button", __assign({ ref: ref, className: cn('z-[51] flex items-center justify-center transition-colors', !inline && 'absolute left-1/2 transform -translate-x-1/2', // Only apply absolute positioning if not inline
        inline ? 'h-8 w-8 rounded-full' : 'w-6 h-3', // Adjust size when inline
        !inline && (isInputExpanded ? 'top-0 rounded-b-full pb-2' : 'bottom-0 rounded-t-full pt-2'), inline && 'rounded-full p-2', // Add padding and make it fully rounded when inline
        variant === 'default'
            ? 'bg-bot-gradient text-white'
            : 'bg-white/70 backdrop-blur-md shadow-md hover:bg-white/80', className) }, props), icon));
});
FloatingButton.displayName = 'FloatingButton';
export { FloatingButton };
